(function () {
  const galleries = new Set();

  function supportsGridLanes() {
    return window.CSS && CSS.supports && CSS.supports("display", "grid-lanes");
  }

  function resetGallery(gallery) {
    gallery.style.minHeight = "";
    for (const item of gallery.children) {
      item.style.position = "";
      item.style.left = "";
      item.style.top = "";
      item.style.width = "";
    }
  }

  function layoutGallery(gallery) {
    if (supportsGridLanes() || window.matchMedia("(max-width: 749px)").matches) {
      resetGallery(gallery);
      return;
    }

    const styles = window.getComputedStyle(gallery);
    const gap = parseFloat(styles.columnGap || styles.gap) || 18;
    const columns = window.matchMedia("(max-width: 989px)").matches ? 2 : 4;
    const width = gallery.clientWidth;
    const columnWidth = (width - gap * (columns - 1)) / columns;
    const heights = Array(columns).fill(0);

    gallery.style.position = "relative";

    for (const item of gallery.children) {
      const span = item.classList.contains("gtile--wide") && columns > 2 ? 2 : 1;
      const maxStart = columns - span;
      let bestColumn = 0;
      let bestHeight = Infinity;

      for (let index = 0; index <= maxStart; index += 1) {
        const height = Math.max(...heights.slice(index, index + span));
        if (height < bestHeight) {
          bestHeight = height;
          bestColumn = index;
        }
      }

      const itemWidth = columnWidth * span + gap * (span - 1);
      item.style.position = "absolute";
      item.style.width = itemWidth + "px";
      item.style.left = bestColumn * (columnWidth + gap) + "px";
      item.style.top = bestHeight + "px";

      const nextHeight = bestHeight + item.offsetHeight + gap;
      for (let index = bestColumn; index < bestColumn + span; index += 1) {
        heights[index] = nextHeight;
      }
    }

    gallery.style.minHeight = Math.max(...heights) - gap + "px";
  }

  function refresh() {
    for (const gallery of galleries) {
      layoutGallery(gallery);
    }
  }

  function init() {
    document.querySelectorAll(".hhb-grid-lanes-gallery").forEach((gallery) => {
      galleries.add(gallery);
      gallery.querySelectorAll("img").forEach((image) => {
        if (!image.complete) image.addEventListener("load", refresh, { once: true });
      });
    });
    refresh();
  }

  window.addEventListener("resize", refresh);
  document.addEventListener("shopify:section:load", init);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
